import React from 'react';
import { Modal } from 'react-bootstrap';

export default function SelectBubble(props) {
    const { podList, theme } = props;
    return (
        <div>
            <Modal show={props.addToBubble} style={{ backdropFilter: 'none' }} centered aria-labelledby="contained-modal-title-vcenter" dialogClassName={"save-modal"}>
                <div className="modal-header">
                    <h5 className="modal-title"> Save to a Skill Pod</h5>
                    <button type="button" className="close" onClick={() => props.resetModal()} data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <Modal.Body style={{ padding: 0 }} >
                    <div className="d-flex justify-content-start align-items-center buble" onClick={() => props.addSkillPod(null, false)} >
                        <svg width="29" height="29" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7578 15H17.0078V10.25C17.0078 10.1125 16.8953 10 16.7578 10H15.2578C15.1203 10 15.0078 10.1125 15.0078 10.25V15H10.2578C10.1203 15 10.0078 15.1125 10.0078 15.25V16.75C10.0078 16.8875 10.1203 17 10.2578 17H15.0078V21.75C15.0078 21.8875 15.1203 22 15.2578 22H16.7578C16.8953 22 17.0078 21.8875 17.0078 21.75V17H21.7578C21.8953 17 22.0078 16.8875 22.0078 16.75V15.25C22.0078 15.1125 21.8953 15 21.7578 15Z" fill={theme?.bgColor} />
                            <path d="M16.0078 2C8.27656 2 2.00781 8.26875 2.00781 16C2.00781 23.7313 8.27656 30 16.0078 30C23.7391 30 30.0078 23.7313 30.0078 16C30.0078 8.26875 23.7391 2 16.0078 2ZM16.0078 27.625C9.58906 27.625 4.38281 22.4188 4.38281 16C4.38281 9.58125 9.58906 4.375 16.0078 4.375C22.4266 4.375 27.6328 9.58125 27.6328 16C27.6328 22.4188 22.4266 27.625 16.0078 27.625Z" fill={theme?.bgColor} />
                        </svg>

                        {/* <img src='/images/plus-circle.svg' width='29x' height='29px' alt='' /> */}
                        <p style={{ color: theme?.bgColor }} className="p-2">Create new Skill Pod</p>
                    </div>
                    <hr style={{ marginTop: 0, marginRight: 0, marginBottom: 0 }} />
                    <div style={{
                        maxHeight: window.innerWidth > 767 ? 360 : 510,
                        overflow: 'auto',
                        overflowX: 'hidden'
                    }} id="scrollableDiv1">

                        <ul className={podList && podList.length > 10 ? 'bubbleList bubble-overflow mt-2' : 'bubbleList mt-2'}>
                            <form>
                                {
                                    podList !== undefined && podList.map((items, index) => {
                                        return (
                                            <li className="save-content ml-1" key={index}>
                                                <div className='d-flex form-group'>
                                                    <p style={{ marginLeft: index > 8 ? -8 : 0 }}>{index + 1}.</p> &nbsp; &nbsp;
                                                    <label htmlFor={items._id} className="text-capitalize">{items.title}</label>
                                                    <input type="radio" name="bubble" id={items._id} onChange={() => props.selectBubble(items._id)} value={items.title} /><br />
                                                </div>

                                            </li>
                                        )
                                    })}
                            </form>
                        </ul>
                        {/* </InfiniteScroll> */}
                    </div>
                </Modal.Body>
            </Modal>


        </div>
    )
}
